import { MNHotInstance } from '../../../bridge/tableHotInstanceTypes';

/**
 * Returns the Handsontable root DOM element for a HOT instance.
 */
const getHotRootContainerFromHotInstance = (hotInstance: MNHotInstance): HTMLDivElement | null =>
    hotInstance.rootContainer instanceof HTMLDivElement ? hotInstance.rootContainer : null;

/**
 * Returns the closest matching ancestor when it is an `HTMLDivElement`.
 */
const getClosestDiv = (element: Element | null | undefined, selector: string): HTMLDivElement | null => {
    const closestElement = element?.closest(selector);
    return closestElement instanceof HTMLDivElement ? closestElement : null;
};

/**
 * Returns the `.HotTable` wrapper element for a HOT instance.
 */
export const getHotTableElementFromHotInstance = (hotInstance: MNHotInstance): HTMLDivElement | null =>
    getClosestDiv(getHotRootContainerFromHotInstance(hotInstance), '.HotTable');

/**
 * Returns the outer Milanote table element for a HOT instance.
 */
export const getTableElementFromHotInstance = (hotInstance: MNHotInstance): HTMLDivElement | null =>
    getClosestDiv(getHotTableElementFromHotInstance(hotInstance), '.Table');
